import styled from "styled-components";

export const TOAST_CONTAINER_CLASSNAME = "toast";

export const IconContainer = styled.div(() => ({
    display: "flex",
}));

interface ToastContainerProps {
    hasBottomBar?: boolean;
}

export const ToastContainer = styled.div<ToastContainerProps>(({ theme, hasBottomBar = true }) => ({
    [`& .${TOAST_CONTAINER_CLASSNAME}`]: {
        bottom: hasBottomBar ? "calc(98px + var(--sab))" : "calc(16px + var(--sab))",
        left: theme.spacing.medium,
        right: theme.spacing.medium,
        zIndex: 999,
        background: theme.colors[theme.colorMode].background_inverse_Primary,
    },
}));
